import {observer} from "mobx-react";
import {CancelModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, fmsShippingClientDetailStore, growlStore} from "../../../store";
import {useState} from "react";
import {FmsShippingClientForm} from "./FmsShippingClientForm";


const FmsShippingClientDetailPage = observer(function FmsShippingClientDetailPage() {
    const [cancelDialog] = useState(new DialogStore())

    const store = fmsShippingClientDetailStore
    const name = store.loaded?.data.label || ''

    const display = `Versandmandant "${name}"`

    return <Page
        breadcrumb={[
            {
                link: '/fms/shippingclient',
                label: 'Versandverwaltung'
            },
            {
                link: `/fms/shippingclient/${store.id}`,
                label: display
            }
        ]}
    >
        <CancelModalDialog
            store={cancelDialog}
            execute={async () => {
                await store.reset()
            }}
        />
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${store.saving ? 'is-loading' : ''}`,
                    disabled: !(store.dirty && store.valid),
                    action: async () => {
                        const success = await store.save()
                        if (success) {
                            await store.reset()
                            growlStore.add({
                                message: 'Der Versandmandant wurde gespeichert',
                                autoclose: true,
                                closable: true
                            })
                        }
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: store.saving || !store.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <FmsShippingClientForm
            disabled={store.saving}
            value={store.formData}
            validation={store.formValidation}
            onBlur={() => store.validate()}
            onChange={value => store.formData = value}
        />
    </Page>
})

export {
    FmsShippingClientDetailPage
}
